export default __webpack_public_path__ + "static/media/grafema_nutrana_07.b3d3b34c.mp4";